export default __webpack_public_path__ + "static/media/Offer-availed.1a02092c.svg";